import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NotFoundComponent } from '@telia-common-components/404';
import LanguageStore from '@stores/LanguageStore';
import TranslateStore from '@stores/TranslateStore';
import SsoStore from '@stores/SsoStore';
import config from '@config';

interface NotFoundProps {
  languageStore?: LanguageStore;
  translateStore?: TranslateStore;
  ssoStore?: SsoStore;
}

function NotFound(props: NotFoundProps) {
  const {
    languageStore: { currentLanguage },
    translateStore: { globalTranslations },
    ssoStore: { customerType }
  } = props;

  return (
    <NotFoundComponent
      translations={globalTranslations}
      teliaWebUrl={config.teliaUrl}
      currentLang={currentLanguage}
      segment={customerType === 'B2B' ? 'ari' : 'era'}
    />
  );
}

export default inject('languageStore', 'translateStore', 'ssoStore')(observer(NotFound));
